














import Vue from 'vue';
import RemoteDataSelectInput from './RemoteDataSelectInput.vue';

interface ILanguageSelectComponent {
  transformer: (values: string[]) => { iso: string }[];
}

export default Vue.extend({
  components: {
    RemoteDataSelectInput,
  },
  model: {
    event: `change`,
    prop: `value`,
  },
  data(): ILanguageSelectComponent {
    return {
      transformer(values: string[]): { iso: string }[] {
        return values.map((value: string) => {
          return { iso: value.toLocaleUpperCase() };
        });
      },
    };
  },
  props: {
    identifier: {
      default: ``,
      type: String,
    },
    t: {
      required: true,
      type: Object as () => Record<string, string>,
    },
    testSelector: {
      default: ``,
      type: String,
    },
    title: {
      default: ``,
      type: String,
    },
    value: {
      default: `EUR`,
      type: [String, Number],
    },
  },
});
